/**
 * GSAP animations for hhm-process block: scroll-triggered header + staggered process steps, number pop, hover.
 */
(function () {
	'use strict';

	function init() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
			return;
		}
		gsap.registerPlugin(ScrollTrigger);

		const section = document.querySelector('.hhm-process-section');
		if (!section) return;

		const easeSnappy = 'power2.out';
		const easeBack = 'back.out(1.2)';

		// ----- 1. Header: badge, title, description — staggered reveal on scroll -----
		const header = section.querySelector('.hhm-process-header');
		if (header) {
			const badge = header.querySelector('.hhm-process-header__badge');
			const title = header.querySelector('.hhm-process-header__title');
			const desc = header.querySelector('.hhm-process-header__desc');
			const headerEls = [badge, title, desc].filter(Boolean);

			if (headerEls.length) {
				gsap.set(headerEls, { opacity: 0, y: 28 });
				gsap.to(headerEls, {
					opacity: 1,
					y: 0,
					duration: 0.65,
					stagger: 0.12,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: header,
						start: 'top 88%',
						toggleActions: 'play none none none',
					},
				});
			}
		}

		// ----- 2. Process items: staggered reveal — number circles scale in with pop, content fades up -----
		const grid = section.querySelector('.hhm-process-grid');
		const numberEls = section.querySelectorAll('.hhm-process-item__number');
		const contentEls = section.querySelectorAll('.hhm-process-item__content');
		const items = section.querySelectorAll('.hhm-process-item');

		if (grid && numberEls.length) {
			gsap.set(numberEls, { opacity: 0, scale: 0.5 });
			gsap.set(contentEls, { opacity: 0, y: 24 });

			const gridTrigger = {
				trigger: grid,
				start: 'top 82%',
				toggleActions: 'play none none none',
			};

			gsap.to(numberEls, {
				opacity: 1,
				scale: 1,
				duration: 0.5,
				stagger: 0.12,
				ease: easeBack,
				scrollTrigger: gridTrigger,
			});
			gsap.to(contentEls, {
				opacity: 1,
				y: 0,
				duration: 0.5,
				stagger: 0.12,
				delay: 0.08,
				ease: easeSnappy,
				scrollTrigger: gridTrigger,
			});
		}

		// ----- 3. Item hover: subtle lift and number ring -----
		items.forEach(function (item) {
			const numberEl = item.querySelector('.hhm-process-item__number');
			item.addEventListener('mouseenter', function () {
				gsap.to(item, {
					y: -4,
					duration: 0.3,
					ease: easeSnappy,
				});
				if (numberEl) {
					gsap.to(numberEl, {
						scale: 1.08,
						boxShadow: '0 0 0 4px rgba(255,255,255,0.25)',
						duration: 0.3,
						ease: easeSnappy,
					});
				}
			});
			item.addEventListener('mouseleave', function () {
				gsap.to(item, {
					y: 0,
					duration: 0.35,
					ease: easeSnappy,
				});
				if (numberEl) {
					gsap.to(numberEl, {
						scale: 1,
						boxShadow: 'none',
						duration: 0.35,
						ease: easeSnappy,
					});
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
